import { ref } from 'vue';
import { defineStore } from 'pinia';

import ApiPaasStddev from '@/api/ApiPaasStddev';
import { getAxiosErrorStatus, logError } from '@/api/ApiHelpers';

import type { PaasStddevItemRaw, PaasStddevResponse } from '@/api/ApiTypes';
import type { Mountpoint, PaasStddevValue } from '@/stores/types/mapStoreContracts';


export const usePaasStddevStore = defineStore('paasStddevStore', () => {
	const items = ref<Map<Mountpoint, PaasStddevValue>>(new Map());
	const isVisible = ref(false);

	const updateItems = (dbItems: PaasStddevItemRaw[]): void => {
		const newItems = new Map<Mountpoint, PaasStddevValue>();
		for (const item of dbItems) {
			newItems.set(item.mountpoint, {
				value: item.value,
				days: item.days,
			});
		}
		items.value = newItems;
	};

	const handleGet = (responseData: PaasStddevResponse): void => {
		updateItems(responseData.items);
	};

	const handleGetError = (error: unknown): void => {
		if (getAxiosErrorStatus(error) !== 401) {
			logError(error);
		}
	};

	const refresh = (): void => {
		if (isVisible.value) {
			ApiPaasStddev.paasStddevGet(handleGet, handleGetError);
		}
	};

	const setVisibility = (visibility: boolean): void => {
		isVisible.value = visibility;
		refresh();
	};

	return {
		items,
		isVisible,
		setVisibility,
		refresh,
	};
});
